import NoSubsidyRepurchaseCardInfo from '../components/no-subsidy-card-info.vue';
import NoSubsidyRepurchaseButton from '../components/no-subsidy-button.vue';

export const CARD_TYPE = {
  // 单车卡
  BIKE: 'bike',
  // 助立车卡
  E_BIKE: 'ebike',
  // 连续包月卡
  MONTHLY_BIKE: 'monthlyBike',
};
export const NET_IMG = 'https://m.hellobike.com/resource/gallery/919/YCU0e02t_wifi.png'; // 网络错误兜底图
export const SIGN_IMG = 'https://m.hellobike.com/resource/gallery/919/vcF_2dFzpX.png'; // 不符合条件兜底图
export const LOW_VERSION_IMG = 'https://m.hellobike.com/resource/gallery/150/oUYIv3GO_Group%201707483917%20(1)%20(1).png?x-oss-process=image/quality,q_80'; // 低版本兜底图
export const HAHA_COMMAND = {
  bike: '3App更新后，使用口令码可进入优惠购卡页^0Fl7uR^hellobike/',
  ebike: '0更新app后，使用口令码可再次进入购卡活动页^oBRMxh^hellobike/',
};
export const FAIL_CODE = 101; // 网络异常
export const LOW_VERSION_CODE = 301; // 版本过低（仅App）
// export const NO_PERSON = 300; // 未命中人群
// export const SIGN_IN = 303; // 已签约
// export const NO_GOODS = 302; // 命中人群，但无商品


// 协议地址
export const PROTOCOL_URL = {
  RENEWAL: 'https://m.hellobike.com/mf/spa/u_chtrtp/latest/MA2507227328263351575445858.html?activityCode=MA2507227328263351575445858', // 抖音1分卡-自动续费协议
  MEMBER: 'https://m.hellobike.com/mf/spa/u_bpcpxi/latest/MA2507227328263132532113760.html?activityCode=MA2507227328263132532113760', // 抖音1分卡-骑行卡服务协议
};

export const CHARGE_TYPE = {
  // 充值类型
  PAY_AND_SIGN: 1307, // 抖音签约并支付
  PAY_AND_SIGN_MONTHLY: 1308, // 抖音连续包月骑行卡免密代扣
};

export const ORDER_TYPE = {
  NORMAL: 0, // 普通订单
};

// 主按钮行为类型
export const ACTION_TYPE = {
  NORMAL_PAY_AND_SIGN: 1, // 1分钱卡支付并签约
  ACTIVE: 2, // 影子卡激活
  BUY_ONE_MONTH: 3, // 连续包月模式下，单独购买一个月
  BUY_MONTHLY: 4, // 连续包月模式下，购买连续包月
  SHADOW_PAY_AND_SIGN: 5, // 影子卡1分钱支付并签约
  SHADOW_BUY_MONTHLY: 6, // 影子卡连续包月购买并激活
  TWO_WHEEL_CARD_ACTIVE: 7, // 两轮卡激活
  NO_SUBSIDY_REPURCHASE: 8, // 不补贴复购购买并激活
};

export const SCENE_TYPE = {
  NO_SUBSIDY_REPURCHASE: 'NO_SUBSIDY_REPURCHASE', // 不补贴复购流程 - 需求：https://hellobike.yuque.com/gakadl/gqsekm/md5cdneuk1novwbv，后续新的业务场景添加在这里，旧业务场景不需要添加，还走旧逻辑。
};

export const COMPONENT_MAP = {
  NO_SUBSIDY_REPURCHASE: NoSubsidyRepurchaseCardInfo,
};

export const BUTTON_MAP = {
  NO_SUBSIDY_REPURCHASE: NoSubsidyRepurchaseButton,
};
